"use client";

// Importing program data
import React, { useEffect, useState } from "react";
import MainProgram from "./MainProgram";
import UGProgram from "./UGProgram";
import PGProgram from "./PGProgram";
import { useDispatch } from "react-redux";
import { fetchPrograms } from "../../redux/programs/action";
import CoursesUG from "./CoursesUG";
import CoursesPG from "./CoursesPG";
import "../../styles/navbar.scss";
// import { useNavigate } from "react-router-dom";

// ExplorePrograms component
const ExplorePrograms = () => {
  const [isUGProgramVisible, setIsUGProgramVisible] = useState(true);
  const [isPGProgramVisible, setIsPGProgramVisible] = useState(false);
  const [selectedUGProgramIndex, setSelectedUGProgramIndex] = useState(null);
  const [selectedPGProgramIndex, setSelectedPGProgramIndex] = useState(null);
  const [ugProgramRecords, setUgProgramRecords] = useState([]);
  const [pgProgramRecords, setPgProgramRecords] = useState([]);
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const result = await dispatch(fetchPrograms());
      if (Array.isArray(result)) {
        const ugProgramsArray = result.filter(
          (program) => program.level === "Graduation"
        );
        const pgProgramsArray = result.filter(
          (program) => program.level === "Post Graduation"
        );

        // console.log("Fetched Programs:", result);
        // console.log("Filtered UG Programs:", ugProgramsArray);
        // console.log("Filtered PG Programs:", pgProgramsArray);

        // Organize programs
        const organizedUGPrograms = organizePrograms(ugProgramsArray);
        const organizedPGPrograms = organizePrograms(pgProgramsArray);

        // Set state and log immediately after
        setUgProgramRecords(organizedUGPrograms);
        setPgProgramRecords(organizedPGPrograms);

        // Log organized programs right after setting the state
        // console.log(
        //   "Organized UG Programs after setting state:",
        //   organizedUGPrograms
        // );
        // console.log(
        //   "Organized PG Programs after setting state:",
        //   organizedPGPrograms
        // );

        // console.log("Updated UG Programs:", ugProgramRecords);

        setSelectedUGProgramIndex(0);
      } else {
        console.error("Unexpected response format:", result);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const organizePrograms = (programArray) => {
    let organizedArray = [];
    programArray.forEach((record) => {
      const programName = record.programName;
      const existingProgramIndex = organizedArray.findIndex(
        (program) => program.programName === programName
      );

      if (existingProgramIndex === -1) {
        organizedArray.push({
          index: organizedArray.length,
          programName,
          count: 1,
          records: [record],
        });
      } else {
        organizedArray[existingProgramIndex].records.push(record);
        organizedArray[existingProgramIndex].count++;
      }
    });
    return organizedArray;
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  // Function to handle UG program click
  const onUGProgramClick = (id, index) => {
    setSelectedPGProgramIndex(null); // Reset selected PG program index
    setIsPGProgramVisible(false); // Set visibility to false for PG program
    setSelectedUGProgramIndex(index); // Set selected UG program index
  };

  // Function to handle PG program click
  const onPGProgramClick = (id, index) => {
    setSelectedUGProgramIndex(null); // Reset selected UG program index
    setIsUGProgramVisible(false); // Set visibility to false for UG program
    setSelectedPGProgramIndex(index); // Set selected PG program index
  };

  // Toggle visibility of UG programs
  const onUGClick = () => {
    setIsUGProgramVisible(!isUGProgramVisible);
    setIsPGProgramVisible(false);
  };

  // Toggle visibility of PG programs
  const onPGClick = () => {
    setIsPGProgramVisible(!isPGProgramVisible);
    setIsUGProgramVisible(false);
  };

  return (
    <div className="absolute top-0 left-0 z-50 w-screen flex justify-center">
      <div className="explore-programs-dropdown">
        <div className="flex flex-row">
          {/* Left Side - Programs List */}
          <div className="sidebar">
            <h2 className="text-primary-color text-2xl font-semibold pt-6 pb-4 px-6">
              <span className="hidden md:inline">Our Programs</span>
              <span className="md:hidden">Programs</span>
            </h2>

            {/* List of Programs */}
            <div className="text-slate-950 flex flex-col items-start h-[420px]">
              {/* Main Program - UG */}
              <div className="w-full">
                <MainProgram
                  isActive={isUGProgramVisible}
                  onMainProgramClick={onUGClick}
                >
                  UG Program
                </MainProgram>

                {/* UG Sub Programs */}
                <div className={`${isUGProgramVisible ? "mt-2" : "mt-0"} ${isUGProgramVisible ? "max-h-[200px] overflow-y-auto ug-scrollbar" : ""}`}>
                  {isUGProgramVisible &&
                    ugProgramRecords.map((program, index) => (
                      <div key={index}>
                        <UGProgram
                          program={program}
                          onClick={() =>
                            onUGProgramClick(program.records[0].programId, index)
                          }
                          isActive={selectedUGProgramIndex === index}
                        />
                      </div>
                    ))}
                </div>
              </div>

              {/* Main Program - PG */}
              <div className="w-full mt-4">
                <MainProgram
                  isActive={isPGProgramVisible}
                  onMainProgramClick={onPGClick}
                >
                  PG Program
                </MainProgram>

                {/* PG Sub Programs */}
                <div className={`${isPGProgramVisible ? "mt-2" : "mt-0"} ${isPGProgramVisible ? "max-h-[200px] overflow-y-auto pg-scrollbar" : ""}`}>
                  {isPGProgramVisible &&
                    pgProgramRecords.map((program, index) => (
                      <div key={index}>
                        <PGProgram
                          program={program}
                          onClick={() =>
                            onPGProgramClick(program.records[0].programId, index)
                          }
                          isActive={selectedPGProgramIndex === index}
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
  
          {/* Right Side - Course Details */}
          <div className="cards-section">
            <div className="cards-container">
              {/* Render courses based on selected UG program */}
              {selectedUGProgramIndex !== null && (
                <CoursesUG program={ugProgramRecords[selectedUGProgramIndex]} />
              )}
              {/* Render courses based on selected PG program */}
              {selectedPGProgramIndex !== null && (
                <CoursesPG program={pgProgramRecords[selectedPGProgramIndex]} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExplorePrograms;
